// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-form[data-v-53262189]{display:flex;flex-direction:column;justify-content:space-between;height:calc(100% - 56px)}", ""]);
// Exports
module.exports = exports;
